<script lang="ts" setup>
	defineProps<{ isDeactivated?: boolean }>()
	const emits = defineEmits<{
		(arg: 'activate'): void
	}>()
</script>

<template>
	<div class="wrapped-flex py-10">
		<div class="relative text-center">
			<h3 class="py-3 text-lg font-medium text-gray-600"> No Plan Covered </h3>
			<p class="max-w-[375px] text-sm font-normal leading-6 text-gray-500">
				{{
					!isDeactivated
						? 'This staff has no plan, click on the button below to add staff to a plan'
						: 'This staff has no policy as they have been deactivated. Click on the button below to add staff to a plan'
				}}
			</p>

			<div class="wrapped-flex mt-5 gap-y-5">
				<lazy-tools-icon icon="clipboard-document-2" dir="documents" />
				<button
					type="button"
					class="default-btn w-full max-w-[224px] justify-center bg-primary-2"
					@click="emits('activate')"
				>
					{{ isDeactivated ? 'Activate Staff' : 'Add staff to plan' }}
				</button>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.wrapped-flex {
		@apply flex flex-col items-center justify-center;
	}
</style>
